import "../../chunk-5WRI5ZAA.js";

// src/visualBuilder/utils/getEntryPermissionsCached.ts
import { getEntryPermissions } from "./getEntryPermissions.js";
import { createCachedFetch } from "./createCachedFetch.js";
var getEntryPermissionsCached = createCachedFetch(getEntryPermissions, _ref => {
  let {
    entryUid,
    contentTypeUid,
    locale
  } = _ref;
  return `${entryUid}.${contentTypeUid}.${locale}`;
});
export { getEntryPermissionsCached };